angular
  .module('contrast.factory.module', [])
  .factory('ModuleFactory', function ($http, UserService) {
    return {
      merge: function (primary, apps) {
        return $http.put(
          UserService.buildAPIUrl('/modules/' + primary + '/merge'),
          apps
        )
      },
      removeModule: function (appId) {
        return $http['delete'](UserService.buildAPIUrl('/modules/' + appId))
      },
      removeChildsModule: function (appId) {
        return $http['delete'](
          UserService.buildAPIUrl('/modules/' + appId + '/child')
        )
      },
      getAppModules: function (appId, expandValue) {
        return $http.get(UserService.buildAPIUrl('/modules/' + appId), {
          params: { expand: expandValue }
        })
      }
    }
  })
